// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".account-history[data-v-64e442c8] tr.collapsing {\n  -webkit-transition: font 0.5s ease;\n  transition: font 0.5s ease;\n}\n.account-history thead th[data-v-64e442c8] {\n  text-align: left !important;\n  vertical-align: top;\n}\n", ""]);
// Exports
module.exports = exports;
